import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input } from "components/Input/InputComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import {
  setDirty,
  updateInput,
} from "containers/TransferSubscriptionAccendo/store/ActionCreators";
import { getTransferSubscriptionToken } from "containers/TransferSubscriptions/store/ActionCreators";
import * as React from "react";
// tslint:disable-next-line
import ReactGA from "react-ga";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { environment } from "root/environments/environment";
import { CountryEnum } from "root/shared/CountryEnum";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import {
  calculateTotalAmount,
  checkValidity,
  getTransferImage,
} from "root/shared/Utility";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { ITransferActionCreator } from "types/transfer_action_creator";
import { ITransferAmount } from "types/transfer_amount";
import { ITransferSubscriptionAccendoActionCreator } from "types/transfer_subscription_accendo_action_creator";
import { ITransferSubscriptionAccendoFormProps } from "types/transfer_subscription_accendo_form_props";
import { TransferSubscriptionTokenRequest } from "types/transfer_subscription_token_request";

/**
 * Transfer Subscription Accendo Component
 */

class TransferSubscriptionAccendoComponent extends React.Component<
  ITransferSubscriptionAccendoFormProps & LocalizeContextProps
> {
  constructor(
    props: ITransferSubscriptionAccendoFormProps & LocalizeContextProps
  ) {
    super(props);
    this.props.addTranslation(this.props.translation);
    this._inputHandler = this._inputHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
    ReactGA.initialize(environment.gaID);
  }

  public componentDidUpdate(): void {
    if (this.props.token !== undefined)
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.TRANSFER_SUBSCRIPTION,
      });

    return;
  }

  // tslint:disable-next-line:cognitive-complexity
  public render(): React.ReactNode {
    return (
      <form onSubmit={this._submitHandler} autoComplete="off" noValidate={true}>
        <ErrorMessage />
        <div id="box-details-pse">
          <div style={{ marginTop: 15 }}>
            <Container className="custom-container" fluid={true}>
              <Row>
                <Col xs={12}>
                  <div
                    className={getTransferImage(CountryEnum.MX)}
                    id={"transfer-image"}
                    style={{ marginBottom: 12 }}
                  />
                </Col>
                <Col xs={12} fluid={true}>
                  <div className="subtitle-mxn-text font-size-14">
                    <Translate id="transferHelperMessage" />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
          <div>
            <Container className="custom-container" fluid={true}>
              <Row>
                <Col xs={12}>
                  <Input
                    {...this.props.documentEmailInput}
                    change={this._inputHandler}
                    touched={this.props.onTouched}
                    required={false}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <PayButton
          isValid={this.props.isValid}
          totalAmount={this.props.totalAmount}
          isSubscription={false}
          currency={this.props.currency}
          isPayin={true}
          disable={this.props.disablePayButton}
        />
        <Footer showLanguajeToggle={this.props.isLanguageToggleAvailable} />
      </form>
    );
  }

  private _inputHandler(id: string, newValue: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.rules.required = true;
    new_input.rules.isEmail = {};

    new_input.valid = checkValidity(newValue, new_input.rules);
    new_input.value = newValue;

    this.props.onChangeInput(new_input);
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    this.props.tokensSubscription({
      email: this.props.documentEmailInput.value,
    });
  }
}

const mapStateToProps: (
  state: CajitaStore
) => ITransferSubscriptionAccendoFormProps = (
  state: CajitaStore
): ITransferSubscriptionAccendoFormProps => ({
  ...state.transferSubscriptionAccendo,
  totalAmount: calculateTotalAmount(state.config.amount as ITransferAmount),
  amount: state.config.amount,
  callbackUrl: state.config.callback_url,
  isLanguageToggleAvailable: true,
  currency: state.config.currency,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<
    CajitaStore,
    undefined,
    ITransferSubscriptionAccendoActionCreator
  >
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): ITransferActionCreator =>
    dispatch(setDirty(payload)),
  tokensSubscription: (payload: TransferSubscriptionTokenRequest): void =>
    dispatch(getTransferSubscriptionToken(payload)),
});

const TransferSubscriptionAccendo: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withLocalize<ITransferSubscriptionAccendoFormProps & LocalizeContextProps>(
    TransferSubscriptionAccendoComponent
  )
);

export { TransferSubscriptionAccendo };



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptionAccendo/TransferSubscriptionAccendoComponent.tsx